<script lang="ts">
  import { beforeNavigate, goto } from '$app/navigation';
  import { unsavedChanges } from '$lib/unsavedChanges/unsavedChanges.svelte';

  // Renders nothing. Mounted once in the root layout, it is the single place
  // navigation is checked against the registered unsaved-work guards.
  //
  // `cancel()` is synchronous and the confirmation is not, so the shape is
  // cancel-first, then replay the navigation once the user has answered.
  // `allowOnce()` is what keeps the replay from being questioned again: it is
  // consumed by the next `blocks()` call, whenever that arrives. A plain local
  // flag would not do — `history.go` returns before its popstate fires, so a
  // flag cleared synchronously would already be down by then.
  beforeNavigate((nav) => {
    if (!unsavedChanges.blocks(nav.from?.url, nav.to?.url)) return;

    nav.cancel();

    // A page unload has nothing to replay: cancelling is precisely what makes
    // the browser put up its own "Leave site?" dialog, which is the only prompt
    // available there.
    if (nav.willUnload) return;

    void (async () => {
      // Pass the navigation through so the question names a surface this move
      // actually destroys, not merely one that happens to be dirty.
      if (!(await unsavedChanges.confirmLeave(nav.from?.url, nav.to?.url))) return;
      unsavedChanges.allowOnce();

      // A cancelled popstate has already had its history position restored by
      // SvelteKit, so replay it as a history move — `goto` would push a new
      // entry and turn a Back into a Forward.
      if (nav.type === 'popstate' && nav.delta) history.go(nav.delta);
      else if (nav.to) await goto(nav.to.url);
    })();
  });
</script>
